/**
 * 채팅 메시지 본문 → 한 줄 미리보기용 **사람이 읽는 글자만** 남긴 문자열.
 *
 * 왜 필요한가: AI 답변은 표를 ```html ... ``` 블록(orchestrator output_format='html')으로 싣는다.
 * 말풍선은 renderMessageMarkdown 이 표로 그리지만, 검색 결과처럼 **본문을 날것으로 찍는 자리**는
 * `<table style="...">` 태그가 그대로 보인다. 여기서 그 껍데기를 걷어낸다.
 *
 * 렌더가 아니라 **표시용 요약**이므로 정확한 markdown 파싱까지는 하지 않는다(비용 대비 무의미).
 * 안전성 관점에서도 문자열만 다루고 DOM 에 넣지 않는다 — 삽입은 여전히 React 가 escape 한다.
 */

/** 표 셀 경계는 공백으로 바꿔야 "항목내용" 처럼 글자가 붙지 않는다. */
const CELL_BOUNDARY_RE = /<\/(td|th|tr|p|div|li|h[1-6])>/gi;

export function chatPlainPreview(content: string): string {
  if (typeof content !== 'string' || content.length === 0) return '';
  return content
    // ```lang 펜스 표시만 제거 — 안의 글(표 텍스트 등)은 남긴다.
    .replace(/^[ \t]*```[\w-]*[ \t]*$/gm, ' ')
    .replace(CELL_BOUNDARY_RE, ' ')
    .replace(/<[^>]*>/g, '')
    // GFM 표 구분선(| --- | --- |) 은 글이 아니다.
    .replace(/^[ \t]*\|?[ \t:|-]{4,}\|?[ \t]*$/gm, ' ')
    .replace(/^[ \t]*>[ \t]?/gm, '')
    .replace(/^[ \t]*#{1,6}[ \t]+/gm, '')
    .replace(/\*\*(.+?)\*\*/g, '$1')
    .replace(/(^|[^\w*])\*(?!\s)([^*\n]+?)\*(?=[^\w*]|$)/g, '$1$2')
    .replace(/`([^`\n]+)`/g, '$1')
    // [텍스트](url) → 텍스트
    .replace(/\[([^\]\n]*)\]\([^)\s]*\)/g, '$1')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/\s+/g, ' ')
    .trim();
}
